// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5342":"68fbe5bd","8184":"02fa2df5"}[chunkId] + ".chunk.css";
};